export const getFormattedCurrencyValue = (amount = 0, storeCurrencyCode, locale) => {
  try {
    const userLocale = locale || navigator.language || "en-US";
    const formatter = new Intl.NumberFormat(userLocale, {
      style: "currency",
      currency: storeCurrencyCode,
    });

    const formattedAmount = formatter.format(amount);
    return formattedAmount;
  } catch (error) {
    return amount;
  }
};
